var map = {
	"./0+B(白).png": 894,
	"./0Bicon.png": 1520,
	"./345747rZjOb48h.png": 4370,
	"./41_Card_01.JPG": 6805,
	"./4358332b983afee3ab5656373649af6d.jpg": 8244,
	"./4f436024d7509c3014693f3f544e2939.jpg": 8876,
	"./ChatBox.png": 1366,
	"./ChatroomTitle.png": 9138,
	"./CoffeeBean.png": 2333,
	"./Component 16.png": 2702,
	"./Component 17.png": 5332,
	"./EasyMenu.jpg": 3045,
	"./Frame 66.png": 2601,
	"./Frame_time_store.png": 2988,
	"./GameBG.png": 9451,
	"./GameBGM.mp3": 4875,
	"./Logo_gold.png": 4441,
	"./LunchLogo.png": 6176,
	"./Shop01Photo.png": 9158,
	"./Shop02Photo.png": 2360,
	"./Shop03Photo.png": 9699,
	"./Shop04Photo.png": 9475,
	"./Shop05Photo.png": 1446,
	"./Shop06Photo.png": 4025,
	"./Shop07Photo.png": 290,
	"./Shop08Photo.png": 827,
	"./StoreLoadingIMG01.jpg": 2365,
	"./StoreLoadingIMG02.jpg": 1877,
	"./StoreLoadingIMG03.jpg": 8066,
	"./StoreLoadingIMG04.jpg": 5775,
	"./StoreLoadingIMG05.jpg": 7210,
	"./StoreLoadingIMG06.jpg": 3306,
	"./a123ae57abbd86719a445512208ef97a.jpg": 5525,
	"./a1p5h-vj677.svg": 1425,
	"./aboutTitle.png": 4495,
	"./ad2474dfbf8cf2cdcd543dd9a1daef24.jpg": 5327,
	"./bg_tips_num_01 1.png": 6156,
	"./bg_tips_num_01.png": 481,
	"./bg_tips_num_02 1.png": 81,
	"./bg_tips_num_02.png": 9400,
	"./bg_tips_num_03 2.png": 4313,
	"./bg_tips_num_03.png": 4348,
	"./bimg02-1.png": 8695,
	"./bsimg3.png": 5036,
	"./cb205710f32320a9f366f498e43eed0.png": 5406,
	"./cb205710f32320a9f366f498e43eed04 1.png": 7653,
	"./couponBgc.png": 8234,
	"./coupon_icon-removebg-preview.png": 841,
	"./coupon_icon-removebg-preview_02.png": 1417,
	"./d039f45f42bf58c3f7933a5e8a17b664.jpg": 7830,
	"./eebb96d3951ee7a28ea90fc1d287208d.jpg": 5969,
	"./img_store03-2x.jpg": 2822,
	"./img_tips_01 1.png": 5001,
	"./img_tips_01.png": 5336,
	"./img_tips_04 1.png": 943,
	"./img_tips_04.png": 8087,
	"./img_tips_05 1.png": 8859,
	"./img_tips_05.png": 1919,
	"./kv_right_01.jpg": 8125,
	"./mainVisual04_pc.jpg": 5675,
	"./mountain_1475505.png": 6936,
	"./noimage.png": 3263,
	"./quzi1.jpg": 2817,
	"./quzi2.jpg": 4068,
	"./quzi3.jpg": 1799,
	"./quzi4.jpg": 1340,
	"./quzi5.jpg": 8752,
	"./quzi6.jpg": 377,
	"./store_Component_16.png": 5903,
	"./store_img1.png": 2166,
	"./store_video.mp4": 271,
	"./ttl_about_01.png": 3164,
	"./ttl_about_03.png": 9029,
	"./yisell_sound_201404102304403674_88366.mp3": 977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3765;